export const extensionRoutes = [  {
    path: 'extensions/returns',
    loadChildren: () => import('./extensions/return-request-extension/routes'),
  },
  {
    path: 'extensions/vendors',
    loadChildren: () => import('./extensions/multivendor-extension/routes'),
  },
  {
    path: 'extensions/product-reviews',
    loadChildren: () => import('./extensions/product-reviews/routes'),
  },
  {
    path: 'seller-settings',
    loadChildren: () => import('./extensions/store-sites/seller-settings-routes'),
  },
  {
    path: 'store-settings',
    loadChildren: () => import('./extensions/store-sites/store-settings-routes'),
  },
  {
    path: 'settings/profile',
    loadChildren: () => import('./extensions/custom-admin-ui/routes'),
  },
  {
    path: 'settings',
    loadChildren: () => import('./extensions/custom-admin-ui/settings-routes'),
  },
  {
    path: 'store-settings',
    loadChildren: () => import('./extensions/custom-admin-ui/store-settings-routes'),
  },
  {
    path: 'seller-settings',
    loadChildren: () => import('./extensions/custom-admin-ui/seller-settings-routes'),
  },
  {
    path: 'extensions/site-pages',
    loadChildren: () => import('./extensions/site-pages/routes'),
  },
  {
    path: 'store-settings',
    loadChildren: () => import('./extensions/site-pages/store-settings-routes'),
  },
  {
    path: 'store-settings',
    loadChildren: () => import('./extensions/shipping/store-settings-routes'),
  },
  {
    path: 'extensions/product-customization-options',
    loadChildren: () => import('./extensions/customizable-product/routes'),
  },
  {
    path: 'store-settings',
    loadChildren: () => import('./extensions/domain-manager/store-settings-routes'),
  },
  {
    path: 'seller-settings',
    loadChildren: () => import('./extensions/domain-manager/seller-settings-routes'),
  }];
